import request from "@/config/utils/request";
// 公告模板维护列表查询
export function qryNoticeTemplateMaintainList(data) {
  return request({
    url: "/apis/bid-scp/bidc/qryNoticeTemplateMaintainList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}
